module.exports = __webpack_public_path__ + "static/media/headshot.30b2c598.png";